import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OverlayModule } from '@angular/cdk/overlay';
import { PxModule } from '@shared/pipes/px/px.module';
import { MultiSelectComponent } from '@shared/components/multi-select/multi-select.component';
import { SvgModule } from '@shared/components/svg/svg.module';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlModule } from '@shared/pipes/safe-html/safe-html.module';

@NgModule({
  declarations: [MultiSelectComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatCheckboxModule, SvgModule, OverlayModule, PxModule, TranslateModule, SafeHtmlModule],
  exports: [MultiSelectComponent]
})
export class MultiSelectModule {}
